module.exports = __webpack_public_path__ + "static/media/hero-pricing-mobile.67ebdaf4.svg";